<script setup lang="ts">
/**
 * BlankLayout — full-screen chrome-free wrapper. Used by /login and other
 * pre-auth screens that should not show the Aside or Breadcrumb.
 */
</script>

<template>
  <div class="qb-blank">
    <router-view />
  </div>
</template>

<style scoped>
.qb-blank {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  background: var(--qb-surface-ground);
}
</style>
